import { Data2, newId } from '../../../features/data-types'
import { toUpperCase } from '../../../utils/typeUtils'
import { Measure } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Vehicle } from '../state/types'

export const useVehicleBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildVehicle = (data: Data2) => {
        const { id = newId(), name, plate, weight, maxLoadWeight, loadMeasures, archived } = data
        const vehicle: Vehicle = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            plate: toUpperCase(plate!),
            weight: weight! as Measure,
            maxLoadWeight: maxLoadWeight! as Measure,
            loadMeasures: (loadMeasures || []) as Measure[],
            archived: !!archived
        }

        return vehicle
    }

    return {
        buildVehicle
    }
}
